import script from "./bulk-set-facility-allergens-button.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-set-facility-allergens-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__